const maxWorkbookSizeMbs = 5;
export default {
  workbookDir: 'spreadsheets',
  maxWorkbookSizeMbs,
  maxWorkbookSizeBytes: maxWorkbookSizeMbs * 1024 * 1024,
  // 5mb in bytes
  maxWorkbookSourceFileSizeBytes: maxWorkbookSizeMbs * 1024 * 1024 // 5mb in bytes

};